import { Injectable, signal } from '@angular/core';

export interface Toast {
  message: string;
}

/** Lightweight global toast (e.g. "Listing published") — a single
 * app-root-mounted <app-toast/> renders whatever's here, same signal-driven
 * pattern as SignupPromptService. Auto-dismisses after `durationMs`; call
 * hide() to dismiss early. */
@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toast = signal<Toast | null>(null);
  private dismissTimer: ReturnType<typeof setTimeout> | null = null;

  show(message: string, durationMs = 4500): void {
    if (this.dismissTimer) clearTimeout(this.dismissTimer);
    this.toast.set({ message });
    this.dismissTimer = setTimeout(() => this.hide(), durationMs);
  }

  hide(): void {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
    }
    this.toast.set(null);
  }
}
